// @flow

export const ClickjackingProtector = ({ children }: *) => {
  if (window.top.document.domain !== document.domain) {
    return null;
  }

  return children;
};
